import React from 'react';
import PropTypes from 'prop-types';
import * as LayoutMode from 'constants/layout-mode';
import DifferenceRect from 'components/difference-rect';
import {isActive} from 'utils/interaction-util';
import {getColumnWidth, getColumnX, getFullWidthX} from 'utils/layout-util';
import {isValid} from 'validators/number-validator';
import styles from './index.css';

export default class DifferenceColumnSeries extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    columnSpacing: PropTypes.number,
    columnWidth: PropTypes.number,
    data: PropTypes.array,
    interactive: PropTypes.bool,
    layoutMode: PropTypes.string,
    scaleY: PropTypes.func,
    tickWidth: PropTypes.number,
    transform: PropTypes.string,
    width: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: -1,
    columnSpacing: 2,
    data: [],
    interactive: true,
    scaleY: () => {},
    tickWidth: 0,
    transform: '',
  };

  getColumnHeight(scale, value, expected) {
    if (typeof scale === 'function' && isValid(value) && isValid(expected)) {
      const y1 =
        value > expected
          ? Math.round(scale(value))
          : Math.round(scale(expected));
      const y2 =
        value < expected
          ? Math.round(scale(value))
          : Math.round(scale(expected));
      return Math.abs(y2 - y1);
    }
    return 0;
  }

  getColumnY(scale, value, expected) {
    if (typeof scale === 'function' && isValid(value) && isValid(expected)) {
      return value > expected
        ? Math.round(scale(value))
        : Math.round(scale(expected));
    }
    return 0;
  }

  getColumnFuncX(layoutMode, columnWidth, tickWidth, width, dataLength) {
    return layoutMode === LayoutMode.COLUMN_LAYOUT
      ? (index) => getColumnX(tickWidth, index) + 1
      : (index) => getFullWidthX(width, dataLength, index) - columnWidth / 2;
  }

  render() {
    const {
      activeIndex,
      columnSpacing,
      data,
      interactive,
      layoutMode,
      scaleY,
      tickWidth,
      transform,
      width,
    } = this.props;

    const columnWidth =
      this.props.columnWidth || getColumnWidth(tickWidth, columnSpacing);
    const columnFuncX = this.getColumnFuncX(
      layoutMode,
      columnWidth,
      tickWidth,
      width,
      data.length,
    );
    return (
      <g className={styles.DifferenceColumnSeries} transform={transform}>
        {data.map((datum, index) => {
          const {color, expected, value} = datum;
          const active = isActive(activeIndex, index, interactive);
          const height = this.getColumnHeight(scaleY, value, expected);
          const style = {fill: color};
          const x = columnFuncX(index);
          const y = this.getColumnY(scaleY, value, expected);
          return active && isValid(expected) ? (
            <DifferenceRect
              active={active}
              className={datum.className}
              height={height}
              key={index}
              style={style}
              width={columnWidth}
              x={x}
              y={y}
            />
          ) : null;
        })}
      </g>
    );
  }
}
